<template>
  <esg-base-list name="disclosures"
                 ref="disclosure-list"
                 :clickable="true"
                 @rowClicked="showDetail">
    <template #actions>
      <esg-base-button variant="primary" size="sm"
                       style="width: 100px"
                       @click="pushRoute('/esg/disclosures/new')">생성
      </esg-base-button>
    </template>
    <template #cell(status)="{ value }">
      <td class="text-center align-middle">
        <span class="status-tag" :class="getStatusTagClass(value)">{{ value }}</span>
      </td>
    </template>
  </esg-base-list>
</template>
<script>
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";

export default {
  name: "EsgDisclosureList",
  components: {EsgBaseButton, EsgBaseList},
  activated() {
    this.$refs['disclosure-list'].$refs['table'].initialize();
  },
  methods: {
    showDetail(disclosure) {
      this.pushRoute({name: "disclosureDetail", params: {id: disclosure.disclosureId}});
    },
    getStatusTagClass(status) {
      if (status === 'OPEN') return 'open'
      else if (status === 'CLOSED') return 'closed'
    },
  },
}
</script>

<style>
.status-tag {
  display: inline-block;
  width: 100px;
  height: 29px;
  padding: 4px;
  border-radius: 38px;
  text-align: center;
  font-family: NanumGothic, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.status-tag.open {
  background-color: #CFDDFF;
  color: #1755CC;
}

.status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}
</style>
